import styled from 'styled-components';
import { space, textAlign, SpaceProps, TextAlignProps } from 'styled-system';

interface TypographyProps extends SpaceProps, TextAlignProps {
	'data-at'?: string;
	dataAt?: string;
}

const Display = styled.h1<TypographyProps>`
	font: var(--display);
	${space}
	${textAlign}
`;

const H1 = styled.h1<TypographyProps>`
	font: var(--h1);
	${space}
	${textAlign}
`;

const H2 = styled.h2<TypographyProps>`
	font: var(--h2);
	${space}
	${textAlign}
`;

const H3 = styled.h3<TypographyProps>`
	font: var(--h3);
	${space}
	${textAlign}
`;

const H4Bold = styled.h4.attrs<TypographyProps>(({ dataAt }) => ({
	'data-at': dataAt
}))<TypographyProps>`
	font: var(--h4-bold);
	${space}
	${textAlign}
`;

const H4Regular = styled.h4<TypographyProps>`
	font: var(--h4-regular);
	${space}
	${textAlign}
`;

const LabelBold = styled.h5<TypographyProps>`
	font: var(--label-bold);
	${space}
	${textAlign}
`;

const LabelRegular = styled.p.attrs<TypographyProps>(({ dataAt }) => ({
	'data-at': dataAt
}))<TypographyProps>`
	font: var(--label-regular);
	${space}
	${textAlign}
`;

const Caption = styled.small<TypographyProps>`
	font: var(--caption);
	${space}
	${textAlign}
`;

const CaptionBold = styled.small<TypographyProps>`
	font: var(--caption-bold);
	${space}
	${textAlign}
`;

const SmallBold = styled.small<TypographyProps>`
	font: var(--small-bold);
	${space}
	${textAlign}
`;

const Small = styled.small<TypographyProps>`
	font: var(--small);
	${space}
	${textAlign}
`;

const Tiny = styled.small<TypographyProps>`
	font: var(--small);
	font-size: 8px;
`;

export {
	Display,
	H1,
	H2,
	H3,
	H4Bold,
	H4Regular,
	LabelBold,
	LabelRegular,
	Caption,
	CaptionBold,
	SmallBold,
	Small,
	Tiny
};
